<template>
  <div class="doctor-main-box">
    <!-- <el-carousel
      class="doctor-swiper-container"
      indicator-position="none"
      arrow="never"
      :loop="true"
    >
      <el-carousel-item v-for="item in 4" :key="item">
        <h3 class="small">{{ item }}</h3>
      </el-carousel-item>
    </el-carousel> -->
    <video class="doctor-swiper-container" id="doctorVideo" ref="doctor_video" @click="handleClick1" v-if="doctorinfo&&doctorinfo.intr_video" :src="doctorinfo.intr_video" :poster="doctorinfo.intr_video_image" x5-video-player-type="h5" playsinline="true" webkit-playsinline="true"></video>
    <img class="video-btn" v-show="btnshow" v-if="doctorinfo&&doctorinfo.intr_video" :src="video_btn" @click="handleClick" alt="">
    <img class="doctor-swiper-container" :src="doctorinfo.intr_video_image" v-if="doctorinfo&&!doctorinfo.intr_video">
    <div class="doctor-intro" v-if="doctorinfo">
      <div class="doctor-name f_s_c">
        <div class="doctor-name-1 font-85">{{doctorinfo.zname}}</div>
        <div class="doctor-issue" v-if="doctorinfo.type == 3">问诊过</div>
        <div class="doctor-focus f_c_c" v-else @click.stop="handleToFav(doctorinfo.id,doctorinfo.type)"><img v-if="doctorinfo.type == 1" class="fav-img" src="../../../static/icons/guanzuj@3x.png" alt="">{{doctorinfo.type == 1?'关注':doctorinfo.type == 2?'已关注':''}}</div>
      </div>
      <div class="doctor-position font-65"><span class="doctor-info">{{doctorinfo.position?doctorinfo.position:''}}</span><span class="doctor-info">{{doctorinfo.hospname?doctorinfo.hospname:''}}</span></div>
      <div class="doctor-tag f_s_c" v-if="doctorinfo.label">
          <div class="tag-name f_s_c" v-for="(label_item,label_index) in doctorinfo.label_list" :key="label_index" v-show="label_index<3">{{label_item}}</div>
      </div>
      <div class="doctor-good overflow" v-if="doctorinfo">{{goodable==''?'暂无介绍':goodable}}<div @click="handleMore" v-if="doctorinfo.goodable&&doctorinfo.goodable.length>34" class="more">更多<img src="../../../static/icons/jinru@3x.png" alt="" /></div></div>
      <div class="doctor-obligation f_s_c">
          <div class="obligation-box" v-for="(item,index) in obligation" :key="index">
              <img src="../../../static/icons/icons_yes@3x.png" alt="">
              <div class="obligation-desc font-65">{{item}}</div>
          </div>
      </div>
    </div>
    <div class="doctor-service-box" v-if="doctorinfo">
        <div class="service-title font-85 f_s_c">服务</div>
        <div v-if="doctorinfo.is_graphic==0 ||doctorinfo.is_phone==0 || doctorinfo.is_video==0">
          <div class="service-list-box" :class="{'no-open':doctorinfo.is_graphic==1}" >
            <img v-if="doctorinfo.is_graphic==0" src="../../../static/img/graphic.png" alt="">
            <img v-else src="../../../static/icons/tuwenwz_no@3x.png" alt="">
            <div class="service-content f_s_s_w">
              <div class="service-content-title">图文问诊</div>
              <div class="service-content-price" v-if="doctorinfo.is_graphic==0">￥{{doctorinfo.graphic_money | price}}</div>
              <div class="service-content-desc">不限次数交流、在线开方、药材快递到家</div>
            </div>
            <button class="service-btn f_c_c"  @click="goorder(1)">{{doctorinfo.is_graphic==0?'去咨询':'即将开通'}}</button>
          </div>
          <div class="service-list-box" :class="{'no-open':doctorinfo.is_phone==1}">
            <img v-if="doctorinfo.is_phone==0" src="../../../static/img/phone-issue.png" alt="">
            <img v-else src="../../../static/icons/dianhuawz_no@3x.png" alt="">
            <div class="service-content f_s_s_w">
              <div class="service-content-title">电话问诊</div>
              <div class="service-content-price" v-if="doctorinfo.is_phone==0">￥{{doctorinfo.phone_money | price}}</div>
              <div class="service-content-desc">10分钟通话时长、在线开方、药材快递到家</div>
            </div>
              <button class="service-btn f_c_c"  @click="goorder(2)">{{doctorinfo.is_phone==0?'去咨询':'即将开通'}}</button>
              <p class="xuanze" v-if="doctorinfo.is_phone==0">(80%用户选择)</p>
          </div>
          <div class="service-list-box no-open">
            <!-- <img src="../../../static/img/video-issue.png" alt=""> -->
            <img src="../../../static/icons/shipingwz_no@3x.png" alt="">
            <div class="service-content f_s_s_w">
              <div class="service-content-title">视频问诊</div>
              <!-- <div class="service-content-price f_s_c" v-if="doctorinfo.is_video==0">￥{{doctorinfo.video_money | price}} <span class="tuijian"></span></div> -->
              <div class="service-content-desc">10分钟视频咨询、在线开方、药材快递到家</div>
            </div>
            <!--<button class="service-btn f_c_c" @click="doctorinfo.is_video==0?$router.push('/shipin_order_pay?&doctorid='+doctorinfo.id):$toast.center('视频问诊功能即将开通')">去咨询</button>-->
            <button class="service-btn f_c_c" @click="$toast.center('视频问诊功能即将开通')">即将开通</button>
          </div>
        </div>
        <div style="position:relative;" class="f_c_c_w" v-if="doctorinfo.is_graphic==1 && doctorinfo.is_phone==1 && doctorinfo.is_video==1">
          <img class="no-open-img" src="../../../static/icons/shuju@3x.jpg" alt="">
          <div class="no-open-txt">医生即将开通服务</div>
        </div>
    </div>
    <div class="doctor-service-box doctor-tip">
      <div class="service-title font-85 f_s_c">购前须知</div>
      <ul :class="{'unfold':toggle_show}">
        <li>互联网诊疗仅适用常见病、慢性病复诊患者，急重症患者、首诊患者请前往实体医疗机构就诊。</li>
        <li>复诊时必须提供包含诊断的实体医疗机构的病历资料，针对同诊断复诊。</li>
        <li>医生将在12小时(非工作时间不计入)内回复您，逾期未回复您可选择继续等待或联系客服。</li>
        <li>医生将与您通过图片、文字进行交流。</li>
        <li>医生将根据患者实际情况辨证开方、给出调理建议。</li>
        <li>购买成功后请如实填写问诊单并发送给医生，医生将按照接到问诊单先后顺序回复。</li>
        <li>问诊过程中请避免向医生咨询非患者本人的问题，否则医生有权提前结束咨询。</li>
        <li>本服务有效期:医生首次回复后48小时内有效。</li>
        <li>在线复诊过程中，若由于您无法提供实体医疗机构的诊断证明，或医生无法在线得出和您之前线下实体机构相同的诊断而无法为您开出处方和诊断的情况，将不会退还复诊费用。</li>
        <li>购买即同意<span style="color:rgba(24,144,255,1);" @click="handlePdf(1)">《用户注册协议》、</span><span style="color:rgba(24,144,255,1);" @click="handlePdf(2)">《法律声明与隐私政策》</span>。</li>
      </ul>
      <div class="mask" v-if="!toggle_intro"></div>
      <div class="toggle-btn" @click="handleToggle">
        <img :src="toggle_img" alt="">
      </div>
    </div>
    <div class="doctor-intro-box" :class="{'toggle-intro':toggle_intro}">
      <img class="close-intro" v-if="!toggle_intro" @click="toggle_intro = true" src="../../../static/img/close-intro.png" alt="">
      <div class="doctor-i-b-title f_s_s">
        <img src="../../../static/icons/rect.png" alt="">
        <div class="doctor-i-b-t-desc font-85">擅长</div>
      </div>
      <div class="doctor-i-b-content font-65" style="margin-bottom:1.8rem;" v-if="doctorinfo">{{doctorinfo.goodable}}</div>
      <div class="doctor-i-b-title f_s_s">
        <img src="../../../static/icons/rect.png" alt="">
        <div class="doctor-i-b-t-desc font-85">简介</div>
      </div>
      <div class="doctor-i-b-content font-65" v-if="doctorinfo">{{doctorinfo.introduce}}</div>
      <!-- introduce -->
    </div>
  </div>
</template>
<script>
import http from "../../request/http";
export default {
  data() {
    return {
      doctorid: '',
      doctorinfo:null,
      obligation:['保证医生真实','未接诊随时退','不满意可申诉'],
      doctor_swiper:null,
      toggle_show:false,
      toggle_img:'../../../static/img/pack_up.png',
      toggle_intro:true,
      video_btn:'../../../static/img/play-btn.png',
      video_type:false,
      btnshow:true,
      goodable:''
    };
  },
  computed: {},
  created() {
    this.doctorid = this.$route.query.doctorid;
    this.docInfo(this.doctorid)
  },
  mounted() {
    // document
    setTimeout(() => {
      if(this.$refs.doctor_video){
        this.$refs.doctor_video.addEventListener('ended', this.video_process, false);
      }
    },100)
  },
  filters:{
    price(val){
      if(val){
        return Number(val).toFixed(2)
      }else{
        return '0.00'
      }
    }
  },
  methods: {
    handlePdf(type) {
      let pdf = "";
      if (type == 1) {
        pdf = "user_register_protocol.pdf";
      } else if (type == 2) {
        pdf = "legal_notice.pdf";
      }
      this.$router.push({
        name: "pdf_template",
        query: {
          pdf: pdf,
        },
      });
    },
    handleClick1(){
      this.btnshow = !this.btnshow;
    },
    video_process(){
      this.video_type = false;
      this.video_btn = '../../../static/img/play-btn.png';
      this.btnshow =true;
      this.$forceUpdate();
    },
    handleClick(){
      this.btnshow = false;
      if(!this.video_type){
        this.$refs.doctor_video.play();
        this.video_type = true;
        this.video_btn = '../../../static/img/pause.png';
      }else{
        this.$refs.doctor_video.pause();
        this.video_type = false;
        this.video_btn = '../../../static/img/play-btn.png';
      }
    },
    goorder(type){
      if(type == 1 && this.doctorinfo.is_graphic ==1){
        this.$toast.center('图文问诊功能即将开通');
        return;
      }
      if(type == 2 && this.doctorinfo.is_phone == 1){
        this.$toast.center('电话问诊功能即将开通');
        return;
      }
      this.$router.push({
        path:'/wenzhen_order_pay',
        query:{
          type:type,
          doctorid:this.doctorid
        }
      })
    },
    handleToggle(){
      this.toggle_show = !this.toggle_show;
      if(this.toggle_show){
        this.toggle_img = '../../../static/img/unfold.png'
      }else{
        this.toggle_img = '../../../static/img/pack_up.png'
      }
    },
    docInfo(id) {
      http
        .post("/api/wap/doctor/info", { doctorId: id })
        .then((res) => {
          if (res.data && res.data.length) {
            let data = res.data[0];
            // data.is_num = 0;
            this.docname = data.zname;
            data.graphic_money = data.graphic_money
              ? (data.graphic_money / 100).toFixed(2)
              : 0;
            data.phone_money = data.phone_money
              ? (data.phone_money / 100).toFixed(2)
              : 0;
            data.video_money = data.video_money
              ? (data.video_money / 100).toFixed(2)
              : 0;
            data.label_list = [];
            if (data.label) {
              data.label_list = data.label.split(",");
            }
            // data.is_num = +data.is_graphic + +data.is_phone + +data.is_video;
            this.doctorinfo = data;
            this.goodable = data.goodable&&data.goodable.length>34?data.goodable.slice(0,35)+'...':data.goodable;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleToFav(id,type){
      let data = {
        docid:id,
        fan_tag:+type
      }
      http.post('/api/wap/doctor/fan',data).then(res => {
        if(res.errno == 0){
          this.doctorinfo.type = type == 1?2:1;
        }
      })
    },
    handleMore(){
      this.toggle_intro = false;
    },
    swiper_init(){
        this.doctor_swiper = new Swiper('.doctor-swiper-container',{
            autoplay:true,
            loop:false,
        })
    }
  },
  beforeDestroy(){
    if(this.$refs.doctor_video){
      this.$refs.doctor_video.removeEventListener('ended', this.video_process, false);
    }
  }
};
</script>
<style scoped>
@import "./doctor_main.css";
</style>



// WEBPACK FOOTER //
// src/pages/doctor/doctor_main.vue